// import React, { useEffect, useState } from 'react';
// import {
//     Typography, Box, Button, TextField,
//     Select, MenuItem, FormControl, InputLabel, Grid, Paper,
//     CircularProgress
// } from '@mui/material';
// import { useLocation, useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import apiUrl from '../../Config';

// const AddEditLanguages = () => {
//     const location = useLocation();
//     const navigate = useNavigate();

//     const language = location.state?.language || null;
//     const isEditMode = !!language;
//     const [loading, setLoading] = useState(false)

//     const [formData, setFormData] = useState({
//         name: '',
//         isActive: true,
//     });

//     const [error, setError] = useState('');

//     useEffect(() => {
//         if (isEditMode) {
//             setFormData({
//                 name: language.name || '',
//                 isActive: language.isActive ?? true,
//             });
//         }
//     }, [language, isEditMode]);

//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         setFormData(prev => ({
//             ...prev,
//             [name]: name === 'isActive' ? value === 'true' : value
//         }));
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         setLoading(true)
//         if (!formData.name.trim()) {
//             setError('Name is required');
//             return;
//         }

//         try {
//             if (isEditMode) {
//                 await axios.put(`${apiUrl}/languages/updatelanguage/${language.id}`, formData);
//             } else {
//                 await axios.post(`${apiUrl}/languages/createlanguage`, formData);
//             }

//             navigate('/display-languages'); // Go back to listing page
//         } catch (err) {
//             console.error('Error saving language:', err);
//             setError('Something went wrong. Please try again.');
//         } finally {
//             setLoading(false)
//         }
//     };

//     return (
//         <Grid container justifyContent="left" mt={0.5}>
//             <Paper sx={{ p: { sm: 2, xs: 2, md: 4, lg: 4 }, width: 400, boxShadow: 'none' }}>
//                 <Typography variant="h5" mb={3}>
//                     {isEditMode ? 'Edit Language' : 'Add Language'}
//                 </Typography>

//                 <Box p={2} border={'1px solid lightgrey'}>
//                     <form onSubmit={handleSubmit}>
//                         <TextField
//                             fullWidth
//                             label="Language Name"
//                             name="name"
//                             value={formData.name}
//                             onChange={handleChange}
//                             required
//                             sx={{ mb: 2 }}
//                         />

//                         <FormControl fullWidth sx={{ mb: 2 }}>
//                             <InputLabel>Active</InputLabel>
//                             <Select
//                                 name="isActive"
//                                 value={String(formData.isActive)}
//                                 onChange={handleChange}
//                                 label="Active"
//                             >
//                                 <MenuItem value="true">Yes</MenuItem>
//                                 <MenuItem value="false">No</MenuItem>
//                             </Select>
//                         </FormControl>

//                         {error && (
//                             <Typography color="error" mb={2}>
//                                 {error}
//                             </Typography>
//                         )}

//                         <Box display="flex" justifyContent="right" gap={3}>
//                             <Button variant="outlined" onClick={() => navigate('/display-languages')}>
//                                 Cancel
//                             </Button>
//                             <Button
//                                 variant="contained"
//                                 type="submit"
//                                 disabled={loading}
//                                 startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null}
//                             >
//                                 {loading ? (isEditMode ? 'Updating...' : 'Creating...') : isEditMode ? 'Update' : 'Create'}
//                             </Button>

//                         </Box>
//                     </form>
//                 </Box>
//             </Paper>
//         </Grid>
//     );
// };

// export default AddEditLanguages;


import React, { useEffect, useState } from 'react';
import {
    Typography, Box, Button, TextField,
    Select, MenuItem, FormControl, InputLabel, Grid, Paper,
    CircularProgress
} from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import apiUrl from '../../Config';
import { toast } from 'react-toastify';  // Add this import

const AddEditLanguages = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const language = location.state?.language || null;
    const isEditMode = !!language;
    const [loading, setLoading] = useState(false)

    const [formData, setFormData] = useState({
        name: '',
        isActive: true,
    });

    const [error, setError] = useState({
        name: '',
        submit: '',
    });

    useEffect(() => {
        if (isEditMode) {
            setFormData({
                name: language.name || '',
                isActive: language.isActive ?? true,
            });
        }
    }, [language, isEditMode]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: name === 'isActive' ? value === 'true' : value
        }));

        // Clear error on input change
        setError(prev => ({ ...prev, [name]: '', submit: '' }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validation
        if (!formData.name.trim()) {
            setError(prev => ({ ...prev, name: 'Name is required' }));
            return;
        }

        setLoading(true);
        setError(prev => ({ ...prev, submit: '' }));

        try {
            if (isEditMode) {
                await axios.put(`${apiUrl}/languages/updatelanguage/${language.id}`, formData);
                toast.success('Language updated successfully!');
            } else {
                await axios.post(`${apiUrl}/languages/createlanguage`, formData);
                toast.success('Language created successfully!');
            }

            navigate('/display-languages');
        } catch (err) {
            console.error('Error saving language:', err);
            const msg = err?.response?.data?.message || 'Something went wrong. Please try again.';
            setError(prev => ({ ...prev, submit: msg }));
            toast.error(msg);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Grid container justifyContent="left" mt={0.5}>
            <Paper sx={{ p: { sm: 2, xs: 2, md: 4, lg: 4 }, width: 400, boxShadow: 'none' }}>
                <Typography variant="h5" mb={3}>
                    {isEditMode ? 'Edit Language' : 'Add Language'}
                </Typography>

                <Box p={2} border={'1px solid lightgrey'}>
                    <form onSubmit={handleSubmit}>
                        <TextField
                            fullWidth
                            label="Language Name"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            error={!!error.name}
                            helperText={error.name}
                            sx={{ mb: 2 }}
                            disabled={loading}
                        />

                        <FormControl fullWidth sx={{ mb: 2 }}>
                            <InputLabel>Active</InputLabel>
                            <Select
                                name="isActive"
                                value={String(formData.isActive)}
                                onChange={handleChange}
                                label="Active"
                                disabled={loading}
                            >
                                <MenuItem value="true">Yes</MenuItem>
                                <MenuItem value="false">No</MenuItem>
                            </Select>
                        </FormControl>

                        {error.submit && (
                            <Typography color="error" mb={2}>
                                {error.submit}
                            </Typography>
                        )}

                        <Box display="flex" justifyContent="right" gap={3}>
                            <Button variant="outlined" onClick={() => navigate('/display-languages')} disabled={loading}>
                                Cancel
                            </Button>
                            <Button
                                variant="contained"
                                type="submit"
                                disabled={loading}
                                startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null}
                            >
                                {loading ? (isEditMode ? 'Updating...' : 'Creating...') : isEditMode ? 'Update' : 'Create'}
                            </Button>

                        </Box>
                    </form>
                </Box>
            </Paper>
        </Grid>
    );
};

export default AddEditLanguages;
